// material-ui

// project-imports
import Navigation from './Navigation';
import SimpleBar from 'components/third-party/SimpleBar';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => {
  return (
    <SimpleBar
      sx={{
        '& .simplebar-content': {
          display: 'flex',
          flexDirection: 'column',
          height: '100%', // Ensure container takes full height
          justifyContent: 'space-between' // Ensures spacing and positioning
        }
      }}
    >
      <Navigation />
    </SimpleBar>
  );
};

export default DrawerContent;
